import React, {useEffect, useContext, useState} from 'react'
import useFetch from '../../hooks/fetchMSSQL-hook'
import { useParams, Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { NavigationContext } from '../../context/navigation-context'
import link from '../../assets/images/back_to_list_icon.svg'

export default function RO() {
    const [RO, setRO] = useState([])
    const [items, setItems] = useState([])
    const [initialItems, setInitialItems] = useState([])
    const [sortBy, setSortBy] = useState('MachineFeederNo|ASC')
    const { setHeaderData } = useContext(NavigationContext)
    const {fetchMssqlApi} = useFetch()
    const param = useParams()
    const history = useHistory()
    const machineInventoryId = Number(param.id)

    const sortDefaults = {
        Name: 'ASC',
        MachineFeederNo: 'ASC',
        Quantity: 'DESC'
    }

    const getSortState = () => {
        const [field, dir] = String(sortBy || '').split('|')
        return { field, dir: (dir || '').toUpperCase() }
    }

    const arrow = field => {
        const sortState = getSortState()
        if (sortState.field !== field) return ''
        return sortState.dir === 'ASC' ? ' ▲' : ' ▼'
    }

    const handleHeaderSort = field => {
        const [curField, curDirRaw] = String(sortBy || '').split('|')
        const curDir = (curDirRaw || '').toUpperCase()

        let nextDir
        if (curField === field) {
            nextDir = curDir === 'ASC' ? 'DESC' : 'ASC'
        } else {
            nextDir = sortDefaults[field] || 'ASC'
        }

        setSortBy(`${field}|${nextDir}`)
    }

    const getRo = () => {
        if (!Number.isInteger(machineInventoryId) || machineInventoryId <= 0) {
            history.replace('/ros')
            return
        }

        const sortParam = sortBy && sortBy !== 'none'
            ? `?sortBy=${encodeURIComponent(sortBy)}`
            : ''

        fetchMssqlApi(`ros/${machineInventoryId}${sortParam}`, {}, res => {
            setRO(res[0])
            setInitialItems(res[1])
        })
    }

    useEffect(() => {
        setHeaderData({text: "Szczegóły rozładowania"})
    }, [])

    useEffect(() => {
        getRo()
    }, [sortBy, param.id])

    useEffect(() => {
        setItems(initialItems)
    }, [initialItems])

    return (
        RO && (
        <div>
            <div className='container-xl'>
             <Link to='/ros'>
                    <label to='back' className="btn btn-link ml-1 text-decoration-none mb-3">
                        <img id='back' src={link}></img>
                    </label>
            </Link>
            <div className='card mb-4'>
                <div className='card-header d-flex justify-content-between'>
                    <h5 className='h5 mb-0'>
                        {RO.RO}
                    </h5 >
                </div>
                <div>
                    <table className="table table-striped">
                        <tbody>
                            <tr className='justify-content-center'>
                                <td className='text-center'>Stworzone</td>
                                <td className='text-center'>Automat</td>
                                <td className='text-center'>Ilość rozładowania</td>
                            </tr>
                            <tr className='justify-content-center'>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {RO.Created}
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {RO.MachineFullName}
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center mb-1 mt-1'>
                                        {RO.UnloadQuantity}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
                <div className='card'>
                    {items.length ?
                ( <table className="table table-striped ">
                    <thead>
                        <tr>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Name")}
                            >
                                Produkt{arrow("Name")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("MachineFeederNo")}
                            >
                                Nr sprężyny{arrow("MachineFeederNo")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Quantity")}
                            >
                                Ilość{arrow("Quantity")}
                            </th>
                        </tr>   
                    </thead>
                    <tbody>
                        {items.map((item, idx) => 
                        !item.deleted && 
                        (
                            <tr key={idx}>
                                <td>{item.Name}</td>
                                <td>{item.MachineFeederNo}</td>
                                <td>{item.Quantity}</td>
                            </tr>
                        ))}
                        
                    </tbody>
                    </table>)
                    : 
                    <div className='card'>
                    </div>
                }
                </div>
                
            </div>
        </div>
        )
    )
}